"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PropertyProvider = require("../../utils/PropertyProvider/PropertyProvider");
var _utils = require("acq-utils/lib/utils");
var _excluded = ["to", "href", "children", "qeId", "Component"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Link = exports.Link = function Link(props, context) {
  var _mergeProps = (0, _PropertyProvider.mergeProps)('link', props, context),
    to = _mergeProps.to,
    href = _mergeProps.href,
    children = _mergeProps.children,
    qeId = _mergeProps.qeId,
    Component = _mergeProps.Component,
    remainingProps = _objectWithoutProperties(_mergeProps, _excluded);
  var url = to || href;
  var urlIsExternal = (0, _utils.isUrlExternal)(url);
  if (urlIsExternal) {
    return /*#__PURE__*/_react["default"].createElement("a", _extends({
      "data-qe-id": qeId,
      href: url
    }, remainingProps), children);
  }
  var isAnchorTag = typeof Component === 'string' && Component.toLowerCase() === 'a';
  return /*#__PURE__*/_react["default"].createElement(Component, _extends({
    "data-qe-id": qeId,
    href: isAnchorTag ? url : undefined,
    to: !isAnchorTag ? url : undefined
  }, remainingProps), children);
};
Link.propTypes = {
  Component: _propTypes["default"].oneOf([_propTypes["default"].node, _propTypes["default"].func]).isRequired,
  children: _propTypes["default"].node,
  to: _propTypes["default"].string,
  href: _propTypes["default"].string,
  className: _propTypes["default"].string,
  style: _propTypes["default"].objectOf(_propTypes["default"].string),
  title: _propTypes["default"].string,
  namespace: _propTypes["default"].string,
  qeId: _propTypes["default"].string
};
Link.defaultProps = {
  Component: 'a',
  qeId: 'acq-components-link',
  title: undefined,
  className: undefined,
  href: undefined,
  to: undefined,
  style: undefined,
  children: undefined,
  namespace: ''
};
Link.contextTypes = {
  withProps: _propTypes["default"].func
};